import CdnMixin from '@SHARED/js/Vue/mixins/CdnMixin';
import template from './GalleryField.html';
import MediaGalleryModule from '../../MediaGallery/MediaGalleryModule';

export default {
  name: 'GalleryField',

  template,

  mixins: [CdnMixin],

  components: {
    MediaGalleryModule,
  },

  props: {
    relatedId: {
      type: Number,
      required: true,
    },
    relatedModel: {
      type: String,
      required: true,
    },
    initContent: {
      type: Object,
      required: true,
    },
    uniqueId: String,
  },

  data() {
    return {
      content: this.initContent,
      renderGallery: false,
    };
  },

  created() {
    this.validateContent(this.content);
  },


  // Methods

  methods: {
    openGalleryModal() {
      this.renderGallery = true;
      this.$nextTick(() => {
        this.$refs.galleryComponent.initOnFroalaEditor();
      });
    },

    addMediaFromGallery(event) {
      try {
        event.media.forEach((mediaItem) => {
          if (mediaItem.file_type === 'image') {
            this.content.gallery.push({ path: mediaItem.path });
          }
        });
      } catch (err) {
        throw new Error(err);
      }

      this.$refs.galleryComponent.destroyGallery();
      this.$nextTick(() => {
        this.renderGallery = false;
      });
    },

    removeMedia(mediaIndex) {
      if (typeof this.content.gallery[mediaIndex] !== 'undefined') {
        this.content.gallery.splice(mediaIndex, 1);
      }
    },

    validateContent(content) {
      if (!Array.isArray(content.gallery)) {
        throw new Error('Invalid content given to GalleryField');
      }

      return true;
    },

  },
};
